import brandLockupSource from './streamlain-brand-lockup.json';

export interface StreamLainBrandLockupSource {
  logoSize: number;
  gap: number;
  wordmarkWidth: number;
}

export const STREAMLAIN_BRAND_LOCKUP =
  brandLockupSource as StreamLainBrandLockupSource;
